<template>

    <div class="filter_tags for_desktop" v-if="filterTags && filterTags.length">
        <div class="tag_flex" v-for="(activeFilter, index) in filterTags" :key="index">

            <div class="tag_box" v-if="activeFilter.filter.type === 'slider'">

                <span>{{ $formatPrice(activeFilter.option.from) }} - {{ $formatPrice(activeFilter.option.to) }}</span>
                <SvgHeaderSvg @click="toggleFilter(activeFilter.filter, false)" :type="'close'" />
            </div>
            <div class="tag_flex" v-else>
                <div class="tag_box">
                    <span>{{ activeFilter.option.label }}</span>
                    <SvgHeaderSvg @click="toggleFilter(activeFilter.filter, activeFilter.option.value)" :type="'close'" />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { cyolistStore }  from '@/stores/cyolist/cyolist';

    const listStore         = cyolistStore();
    const { $formatPrice }  = useNuxtApp()
    const route             = useRoute(); 

    const moduleSubType     = route.meta.moduleSubType 
    const filterTags       = computed( () => listStore.getFilterTags()  )


    const toggleFilter = (filter, value, reset = false) => {
      
        if( filter.singleSelect === true || filter.type == 'slider'){
            reset = true
        }

        listStore.toggleSettingFilter({ reset:reset, type: moduleSubType , filter: filter , option : { value : value }})
    }
  
</script>

<style scoped>
.filter_tags{
    background: #f0f3f3;
    min-height: 53px;
    border-radius: 8px;
    padding: 12px 16px 4px 16px;
}
.filter_tags {
    display: flex;
    align-items: center;
}

.tag_flex {
    display: flex;
    align-items: center;
}

.tag_box {
    border: 1px solid var(--green);
    background: #fff;
    border-radius: 4px;
    padding: 0 3px 3px 8px;
    margin: 0 8px 8px 0;
    cursor: pointer;
}

.tag_box span {
    color: #405955;
    font-size: 14px;
    margin-right: 4px;
    text-transform: capitalize;
}

</style>